var cube = require('../cube');
var AsyncDialog = require('./async-dialog');

var MsgBox = function(options) {

  this.dialog_data = null;
  this.ok_callback = null;
  this.cancel_callback = null;
  this.close_callback = null;
  this.dismiss_callback = null;

  MsgBox.$super.call(this, options);
  // cube.__callsuper(MsgBox, this, options);
};

MsgBox = cube.extend(MsgBox, AsyncDialog);

cube.mix(MsgBox.prototype, {

  close: function(){
    this.close_callback && this.close_callback();
    this.___close();
  },

  ___close: function() {
    this.dismiss_callback && this.dismiss_callback();
    MsgBox.$super.prototype.close.call(this);
  },

  _bindEvents: function() {
    MsgBox.$super.prototype._bindEvents.call(this);

    var me = this;

    this._panel.delegate('._j_msgbox_btn_uni', 'click', function(ev) {
      var title = $(ev.target).html();
      var callback = me.dialog_data.buttons[title];
      callback && callback();
      me.___close();
    });

    this._panel.delegate('._j_msgbox_btn_ok', 'click', function(ev) {
      me.ok_callback && me.ok_callback();
      me.___close();
    });

    this._panel.delegate('._j_msgbox_btn_cancel', 'click', function(ev) {
      me.cancel_callback && me.cancel_callback();
      me.___close();
    });

    var key_fn = function(ev) {
      if (ev.keyCode == 13) {
        me.ok_callback && me.ok_callback();
        me.___close();
      }
    };

    $(document).on('keyup', key_fn);
    this.on('beforedestroy', $.proxy(function() {
      $(document).off('keyup', key_fn);
    }, this));
  },
});

cube.mix(MsgBox, {

  info: function(msg, data) {
    var dialog_body ='<div class="modal-body">' +
      '<div class="">' + msg + '</div></div>' +
      '<div class="modal-footer">' +
      '<span class="btn btn-success _j_msgbox_btn_ok">Yes</span>' +
      '</div></div>';
    return this.showDialog(dialog_body, data);
  },

  succ: function(msg, data) {
    return this.success(msg, data);
  },

  success: function(msg, data) {
    var dialog_body ='<div class="modal-body">' +
      '<div class="alert alert-success">' + msg + '</div></div>' +
      '<div class="modal-footer">';

    if (data && data.buttons) {
      cube.forEach(data.buttons, function(callback, title) {
        dialog_body += '<span class="btn btn-success _j_msgbox_btn_uni">' + title + '</span>';
      });
    } else {
      dialog_body +='<span class="btn btn-success _j_msgbox_btn_ok">Yes</span>';
    }
    dialog_body += '</div></div>';

    return this.showDialog(dialog_body, data);
  },

  confirm: function(msg, data) {

    var dialog_body ='<div class="modal-body">' +
      '<div class="alert alert-warning">' + msg + '</div></div>' +
      '<div class="modal-footer">' +
      '<span class="btn btn-danger mr-20 _j_msgbox_btn_ok">Yes</span>' +
      '<span class="btn btn-default _j_msgbox_btn_cancel">Cancel</span>' +
      '</div></div>';
    this.showDialog(dialog_body, data);
  },

  /**
  * on_ok
  * on_close
  * auto_close
  * on_cancel
  * on_auto_close
  * on_dismiss
  * width
  * height
  */
  error: function(msg, data) {

    var dialog_body ='<div class="modal-body">' +
      '<div class="alert alert-danger alert-error">' + msg + '</div></div>' +
      '<div class="modal-footer">' +
      '<span class="btn btn-primary _j_msgbox_btn_ok">OK</span>' +
      '</div></div>';

    this.showDialog(dialog_body, data);
  },

  showDialog: function(body, data) {

    data = data || {};

    var options = {};
    options.width = data.width || 500;
    options.height = data.height ||'auto';
    options.body = body;
    options.dialog_data = data;
    options.cancel_callback = data.on_cancel;
    options.ok_callback = data.on_ok;
    options.close_callback = data.on_close;
    options.dismiss_callback = data.on_dismiss;

    var dialog = new MsgBox(options);
    dialog.show();
    dialog.getPanel().find('._j_msgbox_btn_ok').focus();

    if (data.auto_close)
      dialog.autoClose(data.auto_close, data.on_auto_close);
  }
});
module.exports = MsgBox;



//////////////////
// WEBPACK FOOTER
// ./src/js/~/view/msg-box.js
// module id = 40
// module chunks = 1